import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="answer-clamp"
export default class extends Controller {
  static targets = ["question", "answer"]
  static values = {
    containerHeight: {
      type: Number,
      default: 200
    },
    answerLineHeight: {
      type: Number,
      default: 35
    }
  }

  connect() {
    this.adjustClamp()
  }

  adjustClamp() {
    const questionHeight = this.questionTarget.clientHeight
    const answerHeight = this.containerHeightValue - questionHeight

    const maxLines = Math.floor(answerHeight / this.answerLineHeightValue)
    this.answerTarget.style.display = "-webkit-box"
    this.answerTarget.style.webkitBoxOrient = "vertical"
    this.answerTarget.style.overflow = "hidden"
    this.answerTarget.style.webkitLineClamp = maxLines
  }
}
